import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addUserToFundByLink } from 'services/fund'

export default function useSetAddUserByLink() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddNewUserToFundPayload) => {
            return addUserToFundByLink(payload)
        },
        onSuccess: (data) => {
            toast.success('با موفقیت به صندوق اضافه شدید.')
            navigate(-1)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
